import getInstance from "../config/api";

export default class JobLog {
  static async fetchJobLogs(params) {
    const instance = getInstance();
    const { data } = await instance.get("/joblog", { params });
    return data;
  }
  static async downloadJobLog(params) {
    const instance = getInstance();
    const data = await instance.get("/joblog/csv", { params });
    return data;
  }
  static async fetchJobMonitoring(params) {
    const instance = getInstance();
    const { data } = await instance.get("/jobMonitoring", { params });
    return data;
  }
}
